var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { CircularProgress, useMediaQuery } from '@mui/material';
import dayjs from 'dayjs';
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import React, { useEffect, useState } from 'react';
import { AllEstimateUrl, getAlertsByJobCardIdURL, GetCompaignList, getCustomerComplaintPriceUrl } from '../../../api/url';
import { ReactComponent as CloseIcon } from '../../../assets/images/closeIcon.svg';
import { getLoadingKey } from '../../../builderPackage/common/commonFunctions';
import { DynamicFormBuilderContainer } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container';
import { FormItemTypes } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
import { LOCAL_STORAGE_KEYS } from '../../../constants';
import { getByIdAPI, getListAPI } from '../../../redux/crudSlice';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { getLocalStorageItem } from '../../../utils/storageHelper';
import { dateFormate } from '../../../utils/utils';
import { getCustomerDetailsAPI } from '../../contractSaleInvoice/services/apiCall';
import { ContractInvoiceKeys } from '../../contractSaleInvoice/services/entity';
import { baseLeftItems, baseRightItems, brandLogoBase64, CustomerVoiceColumns, formatAddressMultiline, getLogoByChannel, loadBase64FromImportedImage, PartLabourColumns } from '../services/entity';
import { showSurface } from '../../../redux/awaitedSurfacesSlice';
import ActionMenuList from '../../../builderPackage/components/actionsMenuList';
export var TechnicianPrintPreview = function (_ref) {
    var _installbaseDetailsBy;
    var data = _ref.data, onClose = _ref.onClose;
    console.log('data', data);
    var dispatch = useAppDispatch();
    var selectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
    var SELECTED_CHANNEL = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_CHANNEL);
    var _a = useAppSelector(function (state) { return state.crud; }), installbaseDetailsById = _a.installbaseDetailsById, AllDataEstimate = _a.AllDataEstimate, CampaignDetails = _a.CampaignDetails;
    var _b = useState(), customer = _b[0], setCustomer = _b[1];
    var _c = useState([]), imageViewTypesTabs = _c[0], setImageViewTypesTabs = _c[1];
    var isMobile = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var matchedCampaign = CampaignDetails === null || CampaignDetails === void 0 ? void 0 : CampaignDetails.data.find(function (item) { return (item === null || item === void 0 ? void 0 : item.id) === (data === null || data === void 0 ? void 0 : data.CampaignId); });
    var _d = useState([]), alertsList = _d[0], setAlertsList = _d[1];
    var _e = useState([]), customerComplsints = _e[0], setCustomerComplsints = _e[1];
    var _f = useState(''), logoBase64 = _f[0], setLogoBase64 = _f[1];
    var isRevisited = alertsList.some(function (data) { return data.AlertName === 'Repeat'; });
    var crud = useAppSelector(function (state) { return state.crud; });
    var TotalKMReading = (parseInt(installbaseDetailsById === null || installbaseDetailsById === void 0 || (_installbaseDetailsBy = installbaseDetailsById.data) === null || _installbaseDetailsBy === void 0 ? void 0 : _installbaseDetailsBy.MeterChangeReading) || 0) + (parseInt(data === null || data === void 0 ? void 0 : data.ODOMeterReading) || 0);
    var isSearchLoading = [crud[getLoadingKey('installbaseDetailsById')], crud[getLoadingKey('CampaignDetails')], crud[getLoadingKey(ContractInvoiceKeys.CustomerDetailsKey)], crud[getLoadingKey('getAlertsByJobCardId')]].includes('loading');
    var checklistItems = [];
    imageViewTypesTabs === null || imageViewTypesTabs === void 0 || imageViewTypesTabs.forEach(function (section) {
        var _section$checkListIte;
        section === null || section === void 0 || (_section$checkListIte = section.checkListItems) === null || _section$checkListIte === void 0 || _section$checkListIte.forEach(function (item) {
            var _item$Answers;
            var trueAnswer = item === null || item === void 0 || (_item$Answers = item.Answers) === null || _item$Answers === void 0 ? void 0 : _item$Answers.find(function (ans) { return ans.defaultValue === true; });
            if (trueAnswer) {
                checklistItems.push({
                    // ...item,
                    name: item === null || item === void 0 ? void 0 : item.Question,
                    position: section === null || section === void 0 ? void 0 : section.Name,
                    mark: trueAnswer === null || trueAnswer === void 0 ? void 0 : trueAnswer.Key
                });
            }
        });
    });
    var findChecklistItem = function (name) {
        return checklistItems.find(function (item) { return item.name.trim().toLowerCase() === name.trim().toLowerCase(); });
    };
    var itemsLeft = baseLeftItems.map(function (baseItem) {
        var match = findChecklistItem(baseItem.name);
        return {
            name: baseItem.name,
            pos: match ? match.position.trim().charAt(0).toUpperCase() : '',
            mark: match ? match.mark.trim().charAt(0).toUpperCase() : ''
        };
    });
    var itemsRight = baseRightItems.map(function (baseItem) {
        var match = findChecklistItem(baseItem.name);
        return {
            name: baseItem.name,
            pos: match ? match.position.trim().charAt(0).toUpperCase() : '',
            mark: match ? match.mark.trim().charAt(0).toUpperCase() : ''
        };
    });
    var channelName = SELECTED_CHANNEL === null || SELECTED_CHANNEL === void 0 ? void 0 : SELECTED_CHANNEL.ChannelName;
    var logo = getLogoByChannel(channelName);
    useEffect(function () {
        loadBase64FromImportedImage(logo).then(setLogoBase64);
        fetchCustomerDetails();
        fetchCampaignDetails();
        getJobCardAlerts();
        getCustomerComplaints();
    }, []);
    var getCustomerComplaints = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _res$payload, priceMap, res, _res$payload2, _data$CustomerComplai, priceMap_1, enrichedDetails;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    priceMap = {};
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "",
                            url: getCustomerComplaintPriceUrl,
                            request: {
                                EstimateId: data === null || data === void 0 ? void 0 : data.ParentId
                            }
                        }))];
                case 1:
                    res = _a.sent();
                    if (res !== null && res !== void 0 && (_res$payload = res.payload) !== null && _res$payload !== void 0 && _res$payload.success) {
                        priceMap_1 = {};
                        res === null || res === void 0 || (_res$payload2 = res.payload) === null || _res$payload2 === void 0 || (_res$payload2 = _res$payload2.data) === null || _res$payload2 === void 0 || _res$payload2.forEach(function (item) {
                            priceMap_1[item === null || item === void 0 ? void 0 : item.ComplaintId] = {
                                PartPrice: parseFloat((item === null || item === void 0 ? void 0 : item.PartPrice) || '0').toFixed(2),
                                LabourPrice: parseFloat((item === null || item === void 0 ? void 0 : item.LabourPrice) || '0').toFixed(2)
                            };
                        });
                        enrichedDetails = data === null || data === void 0 || (_data$CustomerComplai = data.CustomerComplaints) === null || _data$CustomerComplai === void 0 ? void 0 : _data$CustomerComplai.map(function (item) {
                            var priceInfo = priceMap_1[item === null || item === void 0 ? void 0 : item.ComplaintId];
                            var partPrice = priceInfo ? parseFloat(priceInfo.PartPrice) : 0;
                            var labourPrice = priceInfo ? parseFloat(priceInfo.LabourPrice) : 0;
                            var hasPrice = partPrice > 0 || labourPrice > 0;
                            return _objectSpread(_objectSpread({}, item), {}, {
                                PartPrice: partPrice > 0 ? partPrice.toFixed(2) : '',
                                LabourPrice: labourPrice > 0 ? labourPrice.toFixed(2) : '',
                                TotalPrice: hasPrice ? (partPrice + labourPrice).toFixed(2) : ''
                            });
                        });
                        setCustomerComplsints(enrichedDetails);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var fetchCustomerDetails = function () { return __awaiter(void 0, void 0, void 0, function () {
        var customerDetails, _customerData$Person, _customerData$Person2, _customerData$PersonC, _customerData$Address, customerData, customerDetail, request, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(data !== null && data !== void 0 && data.CustomerId)) return [3 /*break*/, 2];
                    return [4 /*yield*/, getCustomerDetailsAPI({
                            request: {
                                id: data === null || data === void 0 ? void 0 : data.CustomerId
                            }
                        })];
                case 1:
                    customerDetails = _a.sent();
                    if (customerDetails !== null && customerDetails !== void 0 && customerDetails.success) {
                        customerData = customerDetails === null || customerDetails === void 0 ? void 0 : customerDetails.data;
                        customerDetail = {
                            PersonName: "".concat((customerData === null || customerData === void 0 || (_customerData$Person = customerData.Person) === null || _customerData$Person === void 0 ? void 0 : _customerData$Person.GivenName) || '', " ").concat((customerData === null || customerData === void 0 || (_customerData$Person2 = customerData.Person) === null || _customerData$Person2 === void 0 ? void 0 : _customerData$Person2.FamilyName) || '').trim(),
                            PrimaryContact: (customerData === null || customerData === void 0 || (_customerData$PersonC = customerData.PersonContact) === null || _customerData$PersonC === void 0 ? void 0 : _customerData$PersonC.find(function (contact) { return (contact === null || contact === void 0 ? void 0 : contact.ContactType) === "Primary"; })) || null,
                            Address: [customerData === null || customerData === void 0 || (_customerData$Address = customerData.Address) === null || _customerData$Address === void 0 || (_customerData$Address = _customerData$Address[0]) === null || _customerData$Address === void 0 ? void 0 : _customerData$Address.Address1 // customerData?.Address?.[0]?.Address2,
                                // customerData?.Address?.[0]?.Address3,
                                // customerData?.Address?.[0]?.Address4
                            ].filter(Boolean).join(', ')
                        };
                        setCustomer(customerDetail);
                    }
                    _a.label = 2;
                case 2:
                    request = {
                        JobCardId: data === null || data === void 0 ? void 0 : data.JobCardId
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "AllDataEstimate",
                            url: AllEstimateUrl,
                            request: request
                        }))];
                case 3:
                    response = _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var fetchCampaignDetails = function () { return __awaiter(void 0, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(getByIdAPI({
                        key: 'CampaignDetails',
                        url: GetCompaignList,
                        request: {
                            id: data === null || data === void 0 ? void 0 : data.CampaignId
                        }
                    }))];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var getJobCardAlerts = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _data$Key, _result$payload, _result$payload2, _result$payload3, requestBody, result, _result$payload4, _UpdatedList, UpdatedList;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestBody = {
                        SystemName: (_data$Key = data === null || data === void 0 ? void 0 : data.Key) !== null && _data$Key !== void 0 ? _data$Key : null,
                        InstallBaseId: data === null || data === void 0 ? void 0 : data.InstallBaseId
                    };
                    requestBody.ParentId = data === null || data === void 0 ? void 0 : data.jobCardId;
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: 'getAlertsByJobCardId',
                            url: getAlertsByJobCardIdURL,
                            request: requestBody
                        }))];
                case 1:
                    result = _a.sent();
                    if (result !== null && result !== void 0 && (_result$payload = result.payload) !== null && _result$payload !== void 0 && (_result$payload = _result$payload.value) !== null && _result$payload !== void 0 && _result$payload.success && result !== null && result !== void 0 && (_result$payload2 = result.payload) !== null && _result$payload2 !== void 0 && (_result$payload2 = _result$payload2.value) !== null && _result$payload2 !== void 0 && _result$payload2.data && result !== null && result !== void 0 && (_result$payload3 = result.payload) !== null && _result$payload3 !== void 0 && (_result$payload3 = _result$payload3.value) !== null && _result$payload3 !== void 0 && (_result$payload3 = _result$payload3.data) !== null && _result$payload3 !== void 0 && _result$payload3.Alerts) {
                        UpdatedList = __spreadArray([], (result === null || result === void 0 || (_result$payload4 = result.payload) === null || _result$payload4 === void 0 || (_result$payload4 = _result$payload4.value) === null || _result$payload4 === void 0 || (_result$payload4 = _result$payload4.data) === null || _result$payload4 === void 0 ? void 0 : _result$payload4.Alerts), true);
                        UpdatedList = (_UpdatedList = UpdatedList) === null || _UpdatedList === void 0 ? void 0 : _UpdatedList.map(function (item, index) {
                            if (index === 0) {
                                return _objectSpread(_objectSpread({}, item), {}, {
                                    isExpanded: true
                                });
                            }
                            else {
                                return _objectSpread(_objectSpread({}, item), {}, {
                                    isExpanded: false
                                });
                            }
                        });
                        setAlertsList(UpdatedList);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var organizationAddress;
    if (selectedBranch !== null && selectedBranch !== void 0 && selectedBranch.OrganizationAddress) {
        organizationAddress = formatAddressMultiline(selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationAddress);
    }
    var generatePDF = function () {
        var arguments_1 = arguments;
        return __awaiter(this, void 0, void 0, function () {
            var _data$CustomerVoice$, _data$partDetails, _data$labourDetails, mode, doc, pageHeight, headerHeight, footerHeight, pageWidth, renderDetails, divider2Y, addHeader, addOtherPagesHeader, renderTable, afterCustomerVoiceY, mergedData, maxLength, i, _data$partDetails2, _data$labourDetails2, partItem, labourItem, isMobile_1, pdfBlob, blobUrl, newWindow, iframe_1;
            return __generator(this, function (_a) {
                mode = arguments_1.length > 0 && arguments_1[0] !== undefined ? arguments_1[0] : 'download';
                doc = new jsPDF({
                    orientation: "landscape",
                    unit: "mm",
                    format: "a4"
                });
                pageHeight = doc.internal.pageSize.height;
                headerHeight = 50;
                footerHeight = 10;
                pageWidth = doc.internal.pageSize.getWidth();
                renderDetails = function (title, details, startX, startY) {
                    var valueOffset = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 30;
                    var keyWidth = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 20;
                    var valueWidth = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 30;
                    var lineHeight = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 4;
                    var currentY = startY;
                    doc.setFontSize(8);
                    doc.setFont("helvetica", "bold");
                    doc.text(title, startX, currentY);
                    details.forEach(function (_ref2) {
                        var label = _ref2[0], value = _ref2[1];
                        currentY += lineHeight;
                        doc.setFontSize(7);
                        doc.setFont("helvetica", "bold");
                        doc.text(label, startX, currentY, {
                            maxWidth: keyWidth
                        });
                        doc.setFontSize(7);
                        doc.setFont("helvetica", "normal");
                        var wrappedText = doc.splitTextToSize(value, valueWidth);
                        doc.text(": " + value, startX + valueOffset, currentY, {
                            maxWidth: valueWidth
                        });
                        currentY += (wrappedText.length - 1) * lineHeight;
                    });
                    return currentY;
                };
                addHeader = function (doc) {
                    var _organizationAddress, _customer$PersonName, _customer$PrimaryCont, _customer$PrimaryCont2, _customer$PrimaryCont3, _customer$PrimaryCont4, _customer$Address, _installbaseDetailsBy2, _installbaseDetailsBy3, _installbaseDetailsBy4, _installbaseDetailsBy5, _installbaseDetailsBy6, _installbaseDetailsBy7, _data$SourceDocumentN, _dayjs$format, _data$RepairTypeName, _data$ODOMeterReading, _matchedCampaign$Name;
                    var pageWidth = doc.internal.pageSize.getWidth();
                    var startY = 5;
                    var lineHeight = 4;
                    var logoWidth = 15;
                    var logoHeight = 7;
                    var logoX = 10;
                    var logoY = startY;
                    doc.addImage(logoBase64, "PNG", logoX, logoY, logoWidth, logoHeight);
                    doc.setFontSize(12);
                    doc.setFont("helvetica", "bold");
                    doc.text("JOB CARD", pageWidth / 2, logoY + logoHeight / 2, {
                        align: "center"
                    });
                    var baseY = logoY + logoHeight + 4;
                    var leftX = 10;
                    var leftY = baseY;
                    doc.setFontSize(7);
                    doc.setFont("helvetica", "bold");
                    doc.text(selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationName, leftX, leftY, {
                        maxWidth: 55
                    });
                    doc.setFont("helvetica", "normal");
                    doc.text((_organizationAddress = organizationAddress) !== null && _organizationAddress !== void 0 ? _organizationAddress : '', leftX, leftY + 4, {
                        maxWidth: 55
                    });
                    doc.setLineWidth(0.5);
                    var columnCount = 4;
                    var sectionWidth = pageWidth / columnCount;
                    var customerX = sectionWidth;
                    var customerY = renderDetails("Customer details:", [["Customer name", (_customer$PersonName = customer === null || customer === void 0 ? void 0 : customer.PersonName) !== null && _customer$PersonName !== void 0 ? _customer$PersonName : ''], ["Email", (_customer$PrimaryCont = customer === null || customer === void 0 || (_customer$PrimaryCont2 = customer.PrimaryContact) === null || _customer$PrimaryCont2 === void 0 ? void 0 : _customer$PrimaryCont2.Email) !== null && _customer$PrimaryCont !== void 0 ? _customer$PrimaryCont : ''], ["Contact no.", (_customer$PrimaryCont3 = customer === null || customer === void 0 || (_customer$PrimaryCont4 = customer.PrimaryContact) === null || _customer$PrimaryCont4 === void 0 ? void 0 : _customer$PrimaryCont4.MobileNumber) !== null && _customer$PrimaryCont3 !== void 0 ? _customer$PrimaryCont3 : ''], ["Address", (_customer$Address = customer === null || customer === void 0 ? void 0 : customer.Address) !== null && _customer$Address !== void 0 ? _customer$Address : '']], customerX, baseY, 26, 20, 40);
                    // Vehicle Details
                    var vehicleX = sectionWidth * 2;
                    var vehicleY = renderDetails("Vehicle details:", [["Model", "".concat(installbaseDetailsById === null || installbaseDetailsById === void 0 || (_installbaseDetailsBy2 = installbaseDetailsById.data) === null || _installbaseDetailsBy2 === void 0 ? void 0 : _installbaseDetailsBy2.ProductName, " (").concat(installbaseDetailsById === null || installbaseDetailsById === void 0 || (_installbaseDetailsBy3 = installbaseDetailsById.data) === null || _installbaseDetailsBy3 === void 0 ? void 0 : _installbaseDetailsBy3.ProductCode, ")")], ["Reg. no.", installbaseDetailsById === null || installbaseDetailsById === void 0 || (_installbaseDetailsBy4 = installbaseDetailsById.data) === null || _installbaseDetailsBy4 === void 0 ? void 0 : _installbaseDetailsBy4.RegistrationNo], ["Chassis no.", installbaseDetailsById === null || installbaseDetailsById === void 0 || (_installbaseDetailsBy5 = installbaseDetailsById.data) === null || _installbaseDetailsBy5 === void 0 ? void 0 : _installbaseDetailsBy5.VinNo], ["Engine no.", installbaseDetailsById === null || installbaseDetailsById === void 0 || (_installbaseDetailsBy6 = installbaseDetailsById.data) === null || _installbaseDetailsBy6 === void 0 ? void 0 : _installbaseDetailsBy6.EngineNo], ["Date of sale", installbaseDetailsById !== null && installbaseDetailsById !== void 0 && (_installbaseDetailsBy7 = installbaseDetailsById.data) !== null && _installbaseDetailsBy7 !== void 0 && _installbaseDetailsBy7.SalesInvoiceDate ? dateFormate(installbaseDetailsById === null || installbaseDetailsById === void 0 ? void 0 : installbaseDetailsById.data.SalesInvoiceDate) : "-"]], vehicleX, baseY, 20, 20, 50);
                    // Job Card Details
                    var jobCardX = sectionWidth * 3;
                    var jobCardY = renderDetails("Job card details:", [["Job card no", (_data$SourceDocumentN = data === null || data === void 0 ? void 0 : data.SourceDocumentNo) !== null && _data$SourceDocumentN !== void 0 ? _data$SourceDocumentN : ''], ["Date", (_dayjs$format = dayjs(data === null || data === void 0 ? void 0 : data.JobCardDate).format("DD MMM, YYYY")) !== null && _dayjs$format !== void 0 ? _dayjs$format : ''], ["Service type", (_data$RepairTypeName = data === null || data === void 0 ? void 0 : data.RepairTypeName) !== null && _data$RepairTypeName !== void 0 ? _data$RepairTypeName : ''], ["Current KMs Reading", (_data$ODOMeterReading = data === null || data === void 0 ? void 0 : data.ODOMeterReading) !== null && _data$ODOMeterReading !== void 0 ? _data$ODOMeterReading : ''], ["Total KMs Reading", TotalKMReading !== null && TotalKMReading !== void 0 ? TotalKMReading : ''], ["Odometer replaced at", ""]], jobCardX, baseY, 30, 40, 30);
                    doc.setDrawColor('#DEE4EB');
                    doc.setLineWidth(0.264);
                    var dividerX = sectionWidth - 5;
                    doc.line(dividerX, baseY - logoHeight + 2, dividerX, Math.max(leftY, customerY, vehicleY + 2, jobCardY));
                    var dividerY = Math.max(leftY, customerY, vehicleY, jobCardY) + lineHeight;
                    doc.setDrawColor('#000000');
                    doc.setLineWidth(0.264);
                    doc.line(10, dividerY, pageWidth - 10, dividerY);
                    var revisitedX = 10;
                    var revisitedY = renderDetails("Other details:", [["Revisited", isRevisited ? 'Yes' : 'No'], ["Repeat job", ""]], revisitedX, dividerY + lineHeight);
                    var CampaignX = sectionWidth;
                    var CampaignY = renderDetails("", [["Campaign name", (_matchedCampaign$Name = matchedCampaign === null || matchedCampaign === void 0 ? void 0 : matchedCampaign.Name) !== null && _matchedCampaign$Name !== void 0 ? _matchedCampaign$Name : ''], ["Lost customer", ""]], CampaignX, dividerY + lineHeight);
                    var NPSX = sectionWidth * 2 + 2;
                    var NPSY = renderDetails("", [["NPS", ""], ["No. of complaints in last 6 months", ""]], NPSX, dividerY + lineHeight, 44, 50);
                    var AMCX = sectionWidth * 3;
                    var ASMY = renderDetails("", [["AMC Expiry", ""], ["Hex file update", ""]], AMCX, dividerY + lineHeight);
                    doc.setDrawColor('#DEE4EB');
                    doc.setLineWidth(0.264);
                    divider2Y = Math.max(leftY, CampaignY, NPSY, ASMY) + lineHeight;
                    doc.line(10, divider2Y, pageWidth - 10, divider2Y);
                };
                addOtherPagesHeader = function (doc) {
                    var _data$SourceDocumentN2, _data$RepairTypeName2, _data$ODOMeterReading2;
                    var pageWidth = doc.internal.pageSize.getWidth();
                    var startY = 5;
                    var logoWidth = 12;
                    var logoHeight = 6;
                    var logoX = 10;
                    var logoY = startY;
                    doc.addImage(brandLogoBase64, "PNG", logoX, logoY, logoWidth, logoHeight);
                    doc.setFontSize(12);
                    doc.setFont("helvetica", "bold");
                    doc.text("JOB CARD", pageWidth / 2, logoY + logoHeight / 2, {
                        align: "center"
                    });
                    var baseY = logoY + logoHeight + 4;
                    var leftX = 10;
                    doc.setFontSize(8);
                    doc.setFont("helvetica", "bold");
                    doc.text("Job card details:", leftX, baseY);
                    doc.setFontSize(7);
                    var details = [{
                            label: "Job card no",
                            value: ": ".concat((_data$SourceDocumentN2 = data === null || data === void 0 ? void 0 : data.SourceDocumentNo) !== null && _data$SourceDocumentN2 !== void 0 ? _data$SourceDocumentN2 : '')
                        }, {
                            label: "Date",
                            value: ": ".concat(dayjs(data === null || data === void 0 ? void 0 : data.JobCardDate).format("DD MMM, YYYY"))
                        }, {
                            label: "Repair type",
                            value: ": ".concat((_data$RepairTypeName2 = data === null || data === void 0 ? void 0 : data.RepairTypeName) !== null && _data$RepairTypeName2 !== void 0 ? _data$RepairTypeName2 : '')
                        }, {
                            label: "KM covered",
                            value: ": ".concat((_data$ODOMeterReading2 = data === null || data === void 0 ? void 0 : data.ODOMeterReading) !== null && _data$ODOMeterReading2 !== void 0 ? _data$ODOMeterReading2 : '')
                        }, {
                            label: "Odometer replaced at",
                            value: "---"
                        }, {
                            label: "Effective KM",
                            value: "---"
                        }];
                    var leftMargin = 10;
                    var rightMargin = doc.internal.pageSize.getWidth() + 7;
                    var totalWidth = rightMargin - leftMargin;
                    var sectionWidth = totalWidth / details.length;
                    details.forEach(function (item, index) {
                        var x = leftMargin + sectionWidth * index;
                        doc.setFont("helvetica", "bold");
                        doc.text(item.label, x, baseY + 5);
                        var labelWidth = doc.getTextWidth(item.label + ' ');
                        doc.setFont("helvetica", "normal");
                        doc.text(item.value, x + labelWidth, baseY + 5);
                    });
                    doc.setDrawColor('#000000');
                    doc.setLineWidth(0.264);
                    doc.line(10, baseY + 8, pageWidth - 10, baseY + 8);
                };
                renderTable = function (_ref3) {
                    var _a;
                    var _ref4;
                    var title = _ref3.title, data = _ref3.data, columns = _ref3.columns, startY = _ref3.startY, _b = _ref3.customColumnWidths, customColumnWidths = _b === void 0 ? {} : _b, tableWidth = _ref3.tableWidth, _c = _ref3.marginLeft, marginLeft = _c === void 0 ? 10 : _c, _d = _ref3.isDoubleTable, isDoubleTable = _d === void 0 ? false : _d, emptyColumnIndex = _ref3.emptyColumnIndex, _e = _ref3.marginTop, marginTop = _e === void 0 ? headerHeight + 45 : _e, _f = _ref3.marginBottom, marginBottom = _f === void 0 ? footerHeight : _f, _g = _ref3.isHideTotalRow, isHideTotalRow = _g === void 0 ? false : _g;
                    var formattedData = data === null || data === void 0 ? void 0 : data.map(function (row, index) { return _objectSpread({
                        srNo: index + 1
                    }, row); });
                    var totalRow = columns === null || columns === void 0 ? void 0 : columns.reduce(function (totals, col) {
                        if (['partQuantity', 'labourQuantity', 'partAmount', 'labourAmount', 'PartPrice', 'LabourPrice', 'TotalPrice'].includes(col.field)) {
                            totals[col.field] = data.reduce(function (sum, row) {
                                var value = parseFloat(row[col.field]);
                                return sum + (isNaN(value) ? 0 : value);
                            }, 0).toFixed(2);
                        }
                        else if (col.field === '') {
                            totals[col.field] = '';
                        }
                        else if (col.field === 'srNo') {
                            totals[col.field] = 'Total';
                        }
                        else {
                            totals[col.field] = '';
                        }
                        return totals;
                    }, {});
                    formattedData === null || formattedData === void 0 || formattedData.push(_objectSpread({
                        srNo: 'Total'
                    }, totalRow));
                    doc.setFontSize(8);
                    doc.setFont("helvetica", "bold");
                    doc.text(title, marginLeft, doc.internal.getNumberOfPages() === 1 ? startY + 22 : startY + 7);
                    var totalPagesFinal = 0;
                    autoTable(doc, {
                        head: [columns.map(function (col) { return col.header; })],
                        body: (_ref4 = isHideTotalRow ? data : formattedData) === null || _ref4 === void 0 ? void 0 : _ref4.map(function (row) { return columns.map(function (col) { return row[col.field]; }); }),
                        startY: doc.internal.getNumberOfPages() === 1 ? startY + 25 : startY + 10,
                        margin: {
                            top: marginTop,
                            bottom: marginBottom,
                            left: marginLeft
                        },
                        styles: {
                            fontSize: 7,
                            cellPadding: 1,
                            lineColor: [0, 0, 0],
                            overflow: 'linebreak',
                            lineWidth: 0.2
                        },
                        headStyles: {
                            fillColor: false,
                            textColor: 0,
                            fontSize: 7,
                            fontStyle: "bold"
                        },
                        bodyStyles: {
                            textColor: 0
                        },
                        columnStyles: _objectSpread(_objectSpread({}, customColumnWidths || {}), emptyColumnIndex !== undefined ? (_a = {},
                            _a[emptyColumnIndex] = {
                                cellWidth: 2,
                                lineWidth: {
                                    top: 0,
                                    bottom: 0
                                }
                            },
                            _a) : {}),
                        theme: "grid",
                        tableWidth: tableWidth,
                        didDrawPage: function (data) {
                            var doc = data.doc;
                            var pageNumber = doc.internal.getCurrentPageInfo().pageNumber;
                            totalPagesFinal = doc.internal.getNumberOfPages();
                            var table = data.table;
                            if (pageNumber === 1) {
                                addHeader(doc);
                            }
                            else {
                                addOtherPagesHeader(doc);
                            }
                            table.settings.margin.left = 10;
                            table.settings.margin.right = 10;
                            table.settings.tableWidth = pageWidth - 20;
                        },
                        didParseCell: function (data) {
                            if (isDoubleTable) {
                                if ((data.section === 'body' || data.section === 'head') && data.column.index === 5) {
                                    data.cell.styles.lineWidth = {
                                        top: 0,
                                        bottom: 0,
                                        left: 0.26,
                                        right: 0
                                    };
                                }
                                if (data.section === 'body' && data.column.index === 4) {
                                    data.cell.styles.lineWidth = 0.2;
                                    data.cell.styles.lineColor = [0, 0, 0];
                                }
                            }
                        }
                    });
                };
                doc.setFont("helvetica", "bold");
                doc.setFontSize(7);
                doc.text("Customer voice:", 10, divider2Y ? divider2Y + 5 : headerHeight + 19);
                doc.setFont("helvetica", "normal");
                doc.text((data === null || data === void 0 || (_data$CustomerVoice$ = data.CustomerVoice[0]) === null || _data$CustomerVoice$ === void 0 ? void 0 : _data$CustomerVoice$.CustomerComplaint) || "", 30, headerHeight + 19, {
                    maxWidth: pageWidth - 50
                });
                renderTable({
                    title: "",
                    data: customerComplsints,
                    columns: CustomerVoiceColumns,
                    startY: headerHeight,
                    tableWidth: pageWidth - 20,
                    customColumnWidths: {
                        0: {
                            cellWidth: 9,
                            halign: 'center'
                        },
                        5: {
                            cellWidth: 18,
                            halign: 'right'
                        },
                        6: {
                            cellWidth: 18,
                            halign: 'right'
                        },
                        7: {
                            cellWidth: 18,
                            halign: 'right'
                        }
                    }
                });
                afterCustomerVoiceY = doc.lastAutoTable.finalY - 17;
                doc.setFont("helvetica", "bold");
                doc.setFontSize(8);
                doc.text("Part", 10, afterCustomerVoiceY + 22);
                doc.text("Service", pageWidth / 2, afterCustomerVoiceY + 22);
                mergedData = [];
                maxLength = Math.max((data === null || data === void 0 || (_data$partDetails = data.partDetails) === null || _data$partDetails === void 0 ? void 0 : _data$partDetails.length) || 0, (data === null || data === void 0 || (_data$labourDetails = data.labourDetails) === null || _data$labourDetails === void 0 ? void 0 : _data$labourDetails.length) || 0);
                for (i = 0; i < maxLength; i++) {
                    partItem = (data === null || data === void 0 || (_data$partDetails2 = data.partDetails) === null || _data$partDetails2 === void 0 ? void 0 : _data$partDetails2[i]) || {};
                    labourItem = (data === null || data === void 0 || (_data$labourDetails2 = data.labourDetails) === null || _data$labourDetails2 === void 0 ? void 0 : _data$labourDetails2[i]) || {};
                    mergedData.push({
                        // srNo: i + 1, 
                        partCode: partItem.ChildCode || '',
                        partName: partItem.ChildName || '',
                        partQuantity: partItem.Quantity || '',
                        partAmount: partItem.TotalAmount ? parseFloat(partItem.TotalAmount).toFixed(2) : '',
                        empty: '',
                        // srNo2: i + 1, // For Labour
                        labourCode: labourItem.ChildCode || '',
                        labourName: labourItem.ChildName || '',
                        labourQuantity: labourItem.Quantity || '',
                        labourAmount: labourItem !== null && labourItem !== void 0 && labourItem.TotalAmount ? parseFloat(labourItem === null || labourItem === void 0 ? void 0 : labourItem.TotalAmount).toFixed(2) : ''
                    });
                }
                renderTable({
                    title: "",
                    data: mergedData,
                    columns: PartLabourColumns,
                    startY: afterCustomerVoiceY,
                    tableWidth: pageWidth - 20,
                    marginLeft: 10,
                    isDoubleTable: true,
                    customColumnWidths: {
                        0: {
                            cellWidth: 16,
                            halign: 'center'
                        },
                        1: {
                            cellWidth: 20
                        },
                        2: {
                            cellWidth: 65
                        },
                        3: {
                            cellWidth: 16,
                            halign: 'right'
                        },
                        4: {
                            cellWidth: 20,
                            halign: 'right'
                        },
                        5: {
                            cellWidth: 3,
                            lineWidth: {
                                top: 0,
                                bottom: 0
                            }
                        },
                        6: {
                            cellWidth: 16,
                            halign: 'center'
                        },
                        7: {
                            cellWidth: 20
                        },
                        8: {
                            cellWidth: 65
                        },
                        9: {
                            cellWidth: 16,
                            halign: 'right'
                        },
                        10: {
                            cellWidth: 20,
                            halign: 'right'
                        }
                    },
                    emptyColumnIndex: 5,
                    marginTop: 28
                });
                if (mode === 'download') {
                    doc.save('Job card technician.pdf');
                }
                else if (mode === 'print') {
                    isMobile_1 = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
                    pdfBlob = doc.output('blob');
                    blobUrl = URL.createObjectURL(pdfBlob);
                    if (isMobile_1) {
                        newWindow = window.open(blobUrl);
                        if (newWindow) {
                            newWindow.focus();
                        }
                    }
                    else {
                        iframe_1 = document.createElement('iframe');
                        iframe_1.style.display = 'none';
                        iframe_1.src = blobUrl;
                        document.body.appendChild(iframe_1);
                        iframe_1.onload = function () {
                            var _iframe$contentWindow, _iframe$contentWindow2;
                            (_iframe$contentWindow = iframe_1.contentWindow) === null || _iframe$contentWindow === void 0 || _iframe$contentWindow.focus();
                            (_iframe$contentWindow2 = iframe_1.contentWindow) === null || _iframe$contentWindow2 === void 0 || _iframe$contentWindow2.print();
                        };
                    }
                }
                return [2 /*return*/];
            });
        });
    };
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            spacing: 0,
            rowGap: '20px',
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    display: 'flex',
                    justifyContent: 'space-between',
                    columnSize: 12,
                    spacing: 0,
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            children: 'TechnicianPrint.pdf',
                            columnSize: 0,
                            fontSize: 'xl',
                            fontWeight: 'strong'
                        }, {
                            type: FormItemTypes.IconButton,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(CloseIcon, {
                                fontSize: "small",
                                color: "secondary"
                            }),
                            columnSize: 0,
                            onClick: function () {
                                onClose();
                            },
                            size: 'small',
                            color: 'secondary'
                        }]
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            gap: 1.5,
            flexDirection: isMobile ? 'column' : 'row',
            justifyContent: 'end',
            spacing: 0,
            sx: {
                paddingTop: '24px'
            },
            elements: [{
                    type: FormItemTypes.Button,
                    name: '',
                    children: isSearchLoading ? /*#__PURE__*/ React.createElement(CircularProgress, {
                        size: 20
                    }) : 'Download',
                    columnSize: 0,
                    fullWidth: true,
                    variant: 'outlined',
                    color: 'secondary',
                    setFormState: function (state, e) { return __awaiter(void 0, void 0, void 0, function () {
                        var res;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, dispatch(showSurface({
                                        type: 'Menu',
                                        Component: ActionMenuList,
                                        containerProps: {
                                            anchorEl: e === null || e === void 0 ? void 0 : e.target
                                        },
                                        componentProps: {
                                            items: [{
                                                    id: 'TechnicianPrint',
                                                    children: [, "TechnicianPrint.pdf"]
                                                }]
                                        }
                                    }))];
                                case 1:
                                    res = _a.sent();
                                    if ((res === null || res === void 0 ? void 0 : res.payload) === 'TechnicianPrint') {
                                        generatePDF('download');
                                    }
                                    return [2 /*return*/];
                            }
                        });
                    }); }
                }, {
                    type: FormItemTypes.Button,
                    name: '',
                    children: isSearchLoading ? /*#__PURE__*/ React.createElement(CircularProgress, {
                        size: 20,
                        color: "secondary"
                    }) : 'Print',
                    onClick: function () {
                        generatePDF('print');
                    },
                    color: 'primary',
                    columnSize: 0,
                    fullWidth: true,
                    variant: 'contained'
                }]
        }];
    return /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        gridProps: {
            p: 2,
            gap: 2,
            spacing: 0
        }
    });
};
